const daDK= {
    login: {
      title: 'Log på',
      sign_in_btn: 'Log på'
    },
    bar: {
        logout: 'Log af',
        languages: 'Sprog',
        settings: 'Åbn indstillinger'
    },
    language: {
      name: 'English (US)',
    },
    attributePage: {
        title: 'Attributændringer',
        viewChanges: 'Se ændringer',
        dateTime: 'Dato',
        notificationType: 'Notifikationstype',
        notificationValue: 'Notifikationsværdi',
        oldValue: 'Gammel værdi',
        newValue: 'Ny værdi',
        accept: 'Accepter',
        reject: 'Afslå',
    },
    Home: 'Hjem',
    load: 'Påbegynder indlæsning...',
    Requested: "Krævet",
    Viewed: "Set",
    Executing: "Udfører",
    Completed: "Afsluttet",
    Expired: "Udløbet",
    Cancelled: "Annulleret",
    Error: "Fejl",
    Rejected: "Afvist",
    error: 'Noget gik galt. Prøv igen senere.',
    displayname: 'Visningsnavn',
    givenname: 'Navn',
    surname: 'Efternavn',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Navn',
    firstname: 'Navn',
    lastname: 'Efternavn',
    footer_copyright: 'Alle rettigheder forbeholdes.'
  };
  
  export default daDK;
  